import React from "react";
import { Paragraph } from "../../Textstyles/Styles";
import { Box } from "@sqymagma/elements";

export default ({ children }) => {
  return (
    <Box width={1} my="m">
      <Paragraph>{children}</Paragraph>
    </Box>
  );
};
